import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import NoPrint from "components/NoPrint";
import Stack from "components/Stack";
import Text from "components/Text";

import MemoSectionContextButton from "entities/Memo/components/Sections/ContextButton";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";
import { ISignatureCustomField } from "entities/MemoTemplate/sdk";

export interface IMemoSignatureSection {
  section: IMemoSection;
  dealId: number;
  onUpdate: () => void;
  roleName?: string;
  customFields?: Array<ISignatureCustomField>;
  externalToken?: string;
}

const MemoSignatureSection = ({
  roleName,
  section,
  dealId,
  onUpdate,
  customFields,
  externalToken,
}: IMemoSignatureSection) => {
  const isShareableMemo = useMemo(
    () => !_.isUndefined(externalToken),
    [externalToken]
  );
  return (
    <Box sx={{ breakInside: "avoid" }}>
      <SectionHeader
        label={section.title}
        alignActionButton="right"
        actionButton={
          !isShareableMemo && (
            <NoPrint>
              <Stack direction="row" spacing={1}>
                <MemoSectionContextButton
                  dealId={dealId}
                  section={section}
                  onUpdate={onUpdate}
                />
              </Stack>
            </NoPrint>
          )
        }
      />
      <SectionContent>
        {!section.is_na ? (
          <>
            {!_.isUndefined(roleName) && (
              <Text variant="label" fontWeight={500} marginBottom={0.8}>
                {roleName}
              </Text>
            )}
            <Stack direction="row" gap={5}>
              <Box border={1} width="420px" height="80px">
                <Text sx={{ color: colors.white, fontSize: 0.1 }}>
                  This is a signature field for {roleName}
                </Text>
              </Box>

              <Stack direction="column" gap={2}>
                {customFields?.map((customField, index) => (
                  <Stack>
                    <Text variant="text3" color={colors.gray80} key={index}>
                      {customField.name}
                    </Text>
                    <div style={{ height: "16px" }} />
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </>
        ) : (
          <Text sx={{ opacity: 0.5 }}>N/A</Text>
        )}
      </SectionContent>
    </Box>
  );
};
export default MemoSignatureSection;
